import React, { FC } from 'react';
import Container from '../../../../../Common/Container/Container';
import Section from '../../../Components/Section/Section';
import ServicesCarousel from '../../../Components/Carousels/ServicesCarousel/ServicesCarousel';
import * as classes from './SlideSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { ServicesSliderSectionProps } from '../../../../../Sections/Services/SlideSection/SlideSection';

const SliderSection: FC<ServicesSliderSectionProps> = ({ sliderItems, slideClickAction }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <Section number={'04'} label={t('services.sliderSection.sectionTitle')}>
        <Container>
          <ServicesCarousel items={sliderItems} slideClickAction={slideClickAction} />
        </Container>
      </Section>
    </div>
  );
};

export default SliderSection;
